import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const VerticalSwapIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} onClick={onClick}>
      <g clipPath="url(#clip0_2227_2143)">
        <path d="M10.6673 11.34V6.66667H9.33398V11.34H7.33398L10.0007 14L12.6673 11.34H10.6673ZM6.00065 2L3.33398 4.66H5.33398V9.33333H6.66732V4.66H8.66732L6.00065 2Z" fill="#0C0F24"/>
      </g>
      <defs>
        <clipPath id="clip0_2227_2143">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default VerticalSwapIcon;